export const ProcessStatus = {
  Pending: "PENDING",
  BatchCreating: "BATCH_CREATING",
  BatchCreated: "BATCH_CREATED",
  Processing: "PROCESSING",
  PartialCompleted: "PARTIAL_COMPLETED",
  Completed: "COMPLETED",
  Failed: "FAILED",
} as const;

export type ProcessStatus = (typeof ProcessStatus)[keyof typeof ProcessStatus];

export interface IDownloadedFileResponseModel {
  file_name: string;
  s3_key: string;
}

// ========== PROCESS DETAIL MODELS (for monitoring with items) ==========
export interface IProcessItemDetailModel {
  id: string;
  file_name: string;
  status: string;
  error_message: string | null;
  created_at: string;
}

export interface IProgressModel {
  total: number;
  completed: number;
}

export interface IUserInputModel {
  [key: string]: string;
}

export interface IUserInputViewModel {
  pageNumbers: number[];
  instructions: string;
}

export interface IProcessDetailResponse {
  id: string;
  status: string;
  progress: IProgressModel;
  is_batch: boolean;
  start_at: string | null;
  finished_at: string | null;
  error_message: string | null;
  user_input: IUserInputModel;
  process_items: IProcessItemDetailModel[];
}

export interface IProcessItemDetailViewModel {
  id: string;
  idShort: string;
  fileName: string;
  status: string;
  errorMessage: string | null;
  createdAt: string;
}

export interface IProcessDetailViewModel {
  id: string;
  status: string;
  progress: {
    total: number;
    completed: number;
  };
  isBatch: boolean;
  startAt: string | null;
  finishedAt: string | null;
  errorMessage: string | null;
  userInput: IUserInputViewModel;
  processItems: IProcessItemDetailViewModel[];
}
